import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import Box from './Box';

var calculateAspectRatio = function calculateAspectRatio(width, height) {
  return "".concat((height / width * 100).toFixed(2), "%");
};

var AspectRatioBox = styled(Box).attrs(function (_ref) {
  var _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles,
      $width = _ref.$width,
      $height = _ref.$height;
  return {
    $styles: _objectSpread({
      position: 'relative',
      height: 0,
      overflow: 'hidden',
      paddingTop: calculateAspectRatio($width, $height)
    }, $styles)
  };
}).withConfig({
  displayName: "AspectRatioBox",
  componentId: "sc-1doexx9-0"
})([""]);
export default AspectRatioBox;